@import ../../styles/helpers

.navContainer
    text-align: center
    display: flex
    flex-direction: column
    align-items: center
    gap: $internal_margin
    position: fixed
    height: 100%
    width: $sidebar_size
    ul
        display: flex  
        flex-direction: column
        gap: 25px
    +m
        position: static
        &.simple
            width: $external_margin
            overflow: hidden
            &>*
                display: none

.navItem
    display: block
    border-radius: 100%
    font-size: $icon_size
    &.active
        background-color: $primary
    svg
        fill: $light
        width: $icon_size
        height: $icon_size
        